var map = {
	"./de.png": "64ce",
	"./en.png": "1409",
	"./es.png": "31be",
	"./it.png": "ead4",
	"./pl.png": "98ec",
	"./ua.png": "c61f",
	"./uk.png": "0e52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f202";